import React, { useState } from 'react';
import { useEffect } from 'react';
import { photos } from '../utilities/photos';
import { isLVP } from '../utilities/viewport';
import DesktopCard from './Cards/DesktopCard';
import MobileCard from './Cards/MobileCards';

const Photos = () => {
    const [activePhoto, setActivePhoto] = useState('')
    useEffect(() => window.scrollTo(0,0), [activePhoto])
    const DisplayCard = isLVP ? DesktopCard : MobileCard;
    const gridClassName = isLVP ? "grid-container" : "list-container";
    return <div className="top-padding tan-background">
      {activePhoto && <img className="media-window" alt={activePhoto.title} src={activePhoto} />}
      {!activePhoto && <h2 className="margin-zero">Select an Image</h2>}
      <div className={gridClassName}>
        {photos.map(photo => <DisplayCard id={photo.id} setActiveVideo={setActivePhoto} video={photo}/>)}
      </div>
    </div>
};

export default Photos;